import * as actionTypes from '../actions/actionTypes';

export const loginUserReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.LOGIN_USER_SUCCESS: {
            const userData = Object.assign({}, state, action.payload);
            return userData;
        }
        case actionTypes.LOGOUT_USER: {
            return action.userData;
        }
        case actionTypes.USER_INFO_SUCCESS: {
            const userInfo = Object.assign({}, state, action.payload);
            return userInfo;
        }
        default:
            return state
    }
}